<lib-collapsible-image-list-panel
  [items]="frames()"
  [processing]="processing()"
  [labels]="labels"
  [showEmptyState]="!frames().length"
  [lockedItemLabelKey]="'EDITOR.ANIMATION.SOURCE_FRAME'"
  [reorderFromIndex]="1"
  [reorderPositionFloor]="1"
  [isItemLocked]="isSourceFrame"
  [canDeleteItem]="canMutateFrame"
  [canDuplicateItem]="canMutateFrame"
  (filesSelected)="filesSelected.emit($event)"
  (itemReordered)="frameReordered.emit($event)"
  (itemDeleted)="frameDeleted.emit($event)"
  (itemDuplicated)="frameDuplicated.emit($event)">
  <ng-template #itemMeta let-item>
    <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
    <label class="item-meta-field" (click)="$event.stopPropagation()">
      <span>{{ 'EDITOR.ANIMATION.FRAME_DELAY' | translate }}</span>
      <input
        type="number"
        min="1"
        max="32767"
        step="10"
        [value]="item.durationMs"
        (change)="onDurationChanged(item, $event)" />
    </label>
  </ng-template>
</lib-collapsible-image-list-panel>
